import React, { useContext, useState } from 'react';
import { TabsProps } from 'antd';

import { SettingType } from '@totem/components/settings/constants';
import ZoneMappingPanel from '@totem/components/settings/sections/nozomi/zoneMappings/ZoneMappingPanel';
import IBCard from '@totem/components/ui_components/antDesignOverrides/IBCard';
import IBTabs from '@totem/components/ui_components/antDesignOverrides/IBTabs';
import ContentLayout from '@totem/components/ui_components/page/ContentLayout';
import { permissions } from '@totem/components/userContext/security/permissions/permissions';
import UserProfileContext from '@totem/components/userContext/UserProfileContext';

import '../../settings/settings.css';

const Mappings = () => {
  const { userProfile } = useContext(UserProfileContext);
  const search = window.location.search;
  const params = new URLSearchParams(search);
  const settingsTab = params.get('st');
  const [currentKey, setCurrentKey] = useState<any>(
    typeof settingsTab !== 'undefined' && settingsTab !== null
      ? settingsTab
      : SettingType.ZONE_MAPPING,
  );

  const getTabItems = () => {
    const tabItems: TabsProps['items'] = [];

    if (permissions.systemAdministrator.hasPermissions(userProfile)) {
      tabItems.push({
        key: SettingType.ZONE_MAPPING,
        label: <span>Nozomi Zone Mapping</span>,
        children: <ZoneMappingPanel />,
      });
    }

    return tabItems;
  };

  return (
    <ContentLayout>
      <IBCard isCovered>
        <IBTabs
          activeKey={currentKey}
          onChange={(key) => setCurrentKey(key)}
          items={getTabItems()}
        />
      </IBCard>
    </ContentLayout>
  );
};

export default Mappings;
